import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';

@Component({
  name: 'CmgOrderConfirmationCancelOrderSuccessModal',
})
export default class CmgOrderConfirmationCancelOrderSuccessModal extends Vue {
  get visible(): boolean {
    return this.$store.state.ui.modals.postSubmitCancelOrderSuccess.visible;
  }

  get storefrontImageUrl(): string {
    return this.$appStore.state.cms.images.storeFront.default;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  close(): void {
    this.$services.ui.setModalVisibility('postSubmitCancelOrderSuccess', false);
    this.$services.ui.focusBack();
  }
}
